import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
function getAccessibleLabel(_ref) {
  var t = _ref.t,
    isDeleted = _ref.isDeleted,
    isReply = _ref.isReply,
    isUserComment = _ref.isUserComment,
    authorName = _ref.authorName;
  if (isDeleted) {
    return t('deleted_comment_title');
  }
  if (isUserComment) {
    if (isReply) {
      return t('single_comment_reply_by_you_title');
    }
    return t('single_comment_by_you_title');
  }
  if (isReply) {
    return t('single_comment_reply_title', {
      author: authorName
    });
  }
  return t('single_comment_title', {
    author: authorName
  });
}
var FocusableArticle = styled.article.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "CommentWrapper__FocusableArticle",
  componentId: "sc-5d76a4-0"
})(["&.focus-visible:focus{outline:3px solid ", ";outline-offset:2px;}&:focus:not(.focus-visible){outline:none;}"], function (p) {
  return p.theme.links;
});
var CommentWrapper = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var comment = _ref2.comment,
    isUserComment = _ref2.isUserComment,
    children = _ref2.children;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var id = comment.id,
    author = comment.author,
    parentId = comment.parentId,
    isDeleted = comment.isDeleted;
  var shouldShowComment = comment.repliesCount > 0 || !comment.isDeleted;
  if (!shouldShowComment) {
    return null;
  }
  var accessibleLabel = getAccessibleLabel({
    t: t,
    isReply: Boolean(parentId),
    isUserComment: isUserComment,
    isDeleted: !!isDeleted,
    authorName: author.displayName
  });
  return /*#__PURE__*/React.createElement(FocusableArticle, {
    ref: ref,
    "aria-label": accessibleLabel,
    "aria-describedby": "comment-date-".concat(id)
  }, children);
});
CommentWrapper.displayName = 'CommentWrapper';
export default CommentWrapper;